<div class="recall-order mt-5" style="margin-bottom: 50px;">
  <h1 class="order-header" *ngIf="heading !=='tel'">{{heading}}</h1>
  <h1 class="order-header" *ngIf="heading=='tel'"><p>ООО &quot;Протос Экспертиза&quot;&nbsp;+7 (495) 151-94-59</p>

    <p><a style="color: white!important; text-decoration: underline; font-size: 27px;" href="https://www.gosnadzor.ru/service/list/reestr_licences_99fz/license.php?licNum=%D0%94%D0%AD-00-006706">Лицензия&nbsp;Ростехнадзора на экспертизу зданий и сооружений&nbsp;ДЭ-00-006706</a></p>
  </h1>
  <form action="" method="post" class="newRecall" name="recall">
    <div class="flex-column">
      <ng-container *ngIf="formStep === 1">
      <div class="flex-row gap10-mobile">
        <div class="field">
          <input type="hidden" name="id_base" value="0" class="not-req id_base_recall">
          <input type="hidden" name="service_title" value="Обратный звонок, услуга не указана"
          >

          <label for="id_utel">Ваш телефон:</label>
          <input type="tel" #input_tel placeholder="+7 456 777-88-99" maxlength="20">
        </div>

        <div class="field field_long">

          <label for="id_uname">Ваше имя:</label>
          <input type="text" #input_name placeholder="Иван Васильевич">
        </div>
      </div>

      <div class="order-button_cont" style="margin-top: 0; align-items: end">
        <p class="badge-paragraph">
          <a routerLink="/privacy/" style="text-decoration: underline; color: white!important;">
            Отправляя форму, я даю согласие на обработку моих персональных данных в рамках
            №&nbsp;152-ФЗ «О персональных данных» и соглашаюсь с политикой
            конфиденциальности</a>
        </p>
        <button type="button" class="button__submit call-me_btn" style="height: 50px;" data-class="new-recall"
                (click)="submit(); formStep =2">Перезвоните мне
        </button>
      </div>
      </ng-container>
      <ng-container *ngIf="formStep ===2">
        <h3 class="mt-4">
          Благодарим Вас за обращение!<br>
        </h3>
        <h3 class="mt-3" *ngIf="entryId!==''"><span style="font-weight: 400">Номер вашей заявки</span>&nbsp;<span
          style="color: white!important;">{{entryId}}</span></h3>
        <p class="mt-3">
          Ваша заявка уже передана менеджерам, ожидайте звонка в течение ближайшего времени.
          <br>
          Если Вам требуется срочная консультация, мы всегда на связи в <a
          href="https://api.whatsapp.com/send/?phone=79150683978"
          style="color: #d83f3f!important; text-decoration: underline; text-underline-offset: 2px">чате</a>
        </p>
      </ng-container>
    </div>
  </form>

</div>
